export default {
    en: {
        UPCOMING_TESTIMONIAL_DATA: [{
            content: "I've enjoyed the most the part where it was explained what PBR does best, what it doesn't do, and how to compensate for them with GI. I would recommend this webinar to anyone who has questions concerning the pros and cons of PBR, and how to get the best of it with iClone 7.",
            author: "Ken Kawashima"
        },
        {
            content: "hough the seminar addressed foundational methods to scene building, there is always something new to learn. I learned a few new tricks. Kai is extremely knowledgeable, entertaining and an excellent presenter. Sometimes though - as a suggestions from someone trying to learn the program - it would be nice to get a webinar that demonstrates the lesson step by step rather than jumping around.",
            author: "Joce Leger"
        },
        {
            content: "I like that it felt personal and that you couldn't see everyone elses questions while the webinar was happening, I like that unlike watching a video you feel part of a lecture or a private lesson, really enjoyed it, would def do another!",
            author: "Katrina Talbot"
        },
        {
            content: "Thanks to this webinar I gained increased knowledge about CT8 blending types as well as the use of image overlay utility for fine tuning in CT8. I also saw a effective workflow utilizing CT8,Character Creator, Sculptris and PhotoShop. I will have to watch the video a few more times so that I can take notes to feel more comfortable with the new knowledge and workflow. I watch as many webinars as I can and do recommend them.",
            author: "Vicki Wilson"
        },
        {
            content: "The specific part I enjoyed the most was the step by step live demo in realtime and seeing the immediate generated results and even witnessing the technical issues encountered along the way by the speaker. Yes, I would like to recommend this webinar because I have an opportunity to hear the questions of other participants and the responses they receive.",
            author: "Gee Lam"
        }],
        SPEAKER_INTRODUCTION_DATA: [{
            id: "Cameron_Hines", 
            img: "Speaker_Cameron.jpg",
            name: "Cameron Hines",
            intros: [
                "In pre-production in creating a Mobile Video Game Company",
                "Freelance Animator & 3D Artist at Creating Animated Media (CAM)",
                "Independent Game Maker 2 and Unity Game Designer",
                "Animator - Childish Gambino - \"Deep Web Tour Vlog\"",
            ],
        }, {
            id: "Cris_Moras", 
            img: "Speaker_Cris.jpg",
            name: "Cris Moras (aka Stuckon3D)",
            intros: [
                "3D generalist for more than 25 years",
                "Lighting and compositing specialist for 15 of those 25 years.",
                "Worked on TV shows (Star Trek: voyager, Deep Space mine), music videos, commercials, motion rides, and 13 animated feature films (at PDI/Dreamworks and Walt Disney Animation Studios), among those: Shrek 2 , Big Hero 6, Frozen, and Zootopia, all Oscar winning films.",
                "Director and art director for Westwood Studio Red Alert 2 Franchise and senior lead artist for Disney Interactive",
            ],
        }, {
            id: "Francesco_Tammaccaro",
            img: "Speaker_Francesco.png",
            name: "Francesco Tammaccaro (aka Frank’s Pencil)",
            intros: [
                "1st prize of Animation@Work 2018 contest: YouTuber animation",
                "Reallusion Certified Content Developer for CrazyTalk Animator",
                "Indipendent multimedia artist, over 10 years of experience",
                "Artist - Locogame.co.uk",
                "Trained in VR/AR applications development at EON Reality",
            ],
        }, {
            id: "Julian_Darley",
            img: "Speaker_Julian.jpg",
            name: "Julian Darley",
            intros: [
                "Writing and directing films since the early 1980s, including: music videos, documentaries, animated shorts, live action shorts.",
                "Now in pre-production for a feature film that uses mostly CGI backgrounds and will make heavy use of iClone for previz.",
            ],
        }, {
            id: "James_Martin",
            img: "Speaker_James.jpg",
            name: "James Martin",
            intros: [
                "Reallusion Certified Trainer - 10+ years training and production",
                "VFX Artist - REPLICAS (2017) - LOTUS Entertainment",
                "Character Animator - \"Survivor's Remorse\" - STARZ network",
                "Lead Animator - Corporate Executive Board (CEB)",
                "Lead Animator - \"Plato's Reality Machine\" (2012)",
                "Owner / Artist - MobaCap Motion capture On-Demand",
            ],
        }, {
            id: "Kai_DeNeve",
            img: "Speaker_Kai.jpg",
            name: "Kai DeNeve",
            intros: [
                "Developer Marketing Manager at Reallusion",
                "Reallusion Marketplace Manager",
                "Freelance Animator & 3D Artist at Neat Night Productions",
                "Independent Unreal Engine Game Designer",
                "Video Game Addict",
            ],
        }, {
            id: "Mark_Diaz",
            img: "Speaker_Mark.jpg",
            name: "Mark Diaz",
            intros: [
                "Short Film Director and Editor for Autumn Leave Films",
                "TEDx Speaker",
                "Teacher and CEO at 2DAnimation101",
                "Self-Taught Animator",
            ],
        }, {
            id: "Mike_Sherwood",
            img: "Speaker_mike.jpg",
            name: "Mike Sherwood (aka 3Dtest)",
            intros: [
                "Independent 3D artist and consultant, over 20 years CGI experience",
                "Specialist in real time character modelling and animation",
                "Worked as Creative Director at bioVirtual Ltd",
                "Worked with broadcast and games companies such as the BBC and EA",
                "Originally trained and worked as a theatre actor/ director",
            ],
        }, {
            id: "Tobias_Kolodziey",
            img: "Speaker_ToKo.jpg",
            name: "Tobias Kolodziey (aka ToKoMotion)",
            intros: [
                "Reallusion Certified Content Developer for iClone/Character Creator/CrazyTalk",
                "Owner/Artist - Studio ToKoMotion",
                "Production of Animation - Visualization - Unity Game Dev / VR",
            ],
        }, {
            id: "Viktoriya_Nesterenko",
            img: "Speaker_Viktoriya.jpg",
            name: "Viktoriya Nesterenko",
            intros: [
                "1st prize of Animation@Work 2018 contest: Business animation",
                "Reallusion Certified Director (3D animation) 2016",
                "Independent 3D and 2D artist",
                "Owner/Artist - Nestergal creative school-studio",
            ],
        }],
    },
    de: {
        UPCOMING_TESTIMONIAL_DATA: [{
            content: "I've enjoyed the most the part where it was explained what PBR does best, what it doesn't do, and how to compensate for them with GI. I would recommend this webinar to anyone who has questions concerning the pros and cons of PBR, and how to get the best of it with iClone 7.",
            author: "Ken Kawashima"
        },
        {
            content: "hough the seminar addressed foundational methods to scene building, there is always something new to learn. I learned a few new tricks. Kai is extremely knowledgeable, entertaining and an excellent presenter. Sometimes though - as a suggestions from someone trying to learn the program - it would be nice to get a webinar that demonstrates the lesson step by step rather than jumping around.",
            author: "Joce Leger"
        },
        {
            content: "I like that it felt personal and that you couldn't see everyone elses questions while the webinar was happening, I like that unlike watching a video you feel part of a lecture or a private lesson, really enjoyed it, would def do another!",
            author: "Katrina Talbot"
        },
        {
            content: "Thanks to this webinar I gained increased knowledge about CT8 blending types as well as the use of image overlay utility for fine tuning in CT8. I also saw a effective workflow utilizing CT8,Character Creator, Sculptris and PhotoShop. I will have to watch the video a few more times so that I can take notes to feel more comfortable with the new knowledge and workflow. I watch as many webinars as I can and do recommend them.",
            author: "Vicki Wilson"
        },
        {
            content: "The specific part I enjoyed the most was the step by step live demo in realtime and seeing the immediate generated results and even witnessing the technical issues encountered along the way by the speaker. Yes, I would like to recommend this webinar because I have an opportunity to hear the questions of other participants and the responses they receive.",
            author: "Gee Lam"
        }],
        SPEAKER_INTRODUCTION_DATA: [{
            id: "Cameron_Hines", 
            img: "Speaker_Cameron.jpg",
            name: "Cameron Hines",
            intros: [
                "In pre-production in creating a Mobile Video Game Company",
                "Freelance Animator & 3D Artist at Creating Animated Media (CAM)",
                "Independent Game Maker 2 and Unity Game Designer",
                "Animator - Childish Gambino - \"Deep Web Tour Vlog\"",
            ],
        }, {
            id: "Cris_Moras", 
            img: "Speaker_Cris.jpg",
            name: "Cris Moras (aka Stuckon3D)",
            intros: [
                "3D generalist for more than 25 years",
                "Lighting and compositing specialist for 15 of those 25 years.",
                "Worked on TV shows (Star Trek: voyager, Deep Space mine), music videos, commercials, motion rides, and 13 animated feature films (at PDI/Dreamworks and Walt Disney Animation Studios), among those: Shrek 2 , Big Hero 6, Frozen, and Zootopia, all Oscar winning films.",
                "Director and art director for Westwood Studio Red Alert 2 Franchise and senior lead artist for Disney Interactive",
            ],
        }, {
            id: "Francesco_Tammaccaro",
            img: "Speaker_Francesco.png",
            name: "Francesco Tammaccaro (aka Frank’s Pencil)",
            intros: [
                "1st prize of Animation@Work 2018 contest: YouTuber animation",
                "Reallusion Certified Content Developer for CrazyTalk Animator",
                "Indipendent multimedia artist, over 10 years of experience",
                "Artist - Locogame.co.uk",
                "Trained in VR/AR applications development at EON Reality",
            ],
        }, {
            id: "Julian_Darley",
            img: "Speaker_Julian.jpg",
            name: "Julian Darley",
            intros: [
                "Writing and directing films since the early 1980s, including: music videos, documentaries, animated shorts, live action shorts.",
                "Now in pre-production for a feature film that uses mostly CGI backgrounds and will make heavy use of iClone for previz.",
            ],
        }, {
            id: "James_Martin",
            img: "Speaker_James.jpg",
            name: "James Martin",
            intros: [
                "Reallusion Certified Trainer - 10+ years training and production",
                "VFX Artist - REPLICAS (2017) - LOTUS Entertainment",
                "Character Animator - \"Survivor's Remorse\" - STARZ network",
                "Lead Animator - Corporate Executive Board (CEB)",
                "Lead Animator - \"Plato's Reality Machine\" (2012)",
                "Owner / Artist - MobaCap Motion capture On-Demand",
            ],
        }, {
            id: "Kai_DeNeve",
            img: "Speaker_Kai.jpg",
            name: "Kai DeNeve",
            intros: [
                "Developer Marketing Manager at Reallusion",
                "Reallusion Marketplace Manager",
                "Freelance Animator & 3D Artist at Neat Night Productions",
                "Independent Unreal Engine Game Designer",
                "Video Game Addict",
            ],
        }, {
            id: "Mark_Diaz",
            img: "Speaker_Mark.jpg",
            name: "Mark Diaz",
            intros: [
                "Short Film Director and Editor for Autumn Leave Films",
                "TEDx Speaker",
                "Teacher and CEO at 2DAnimation101",
                "Self-Taught Animator",
            ],
        }, {
            id: "Mike_Sherwood",
            img: "Speaker_mike.jpg",
            name: "Mike Sherwood (aka 3Dtest)",
            intros: [
                "Independent 3D artist and consultant, over 20 years CGI experience",
                "Specialist in real time character modelling and animation",
                "Worked as Creative Director at bioVirtual Ltd",
                "Worked with broadcast and games companies such as the BBC and EA",
                "Originally trained and worked as a theatre actor/ director",
            ],
        }, {
            id: "Tobias_Kolodziey",
            img: "Speaker_ToKo.jpg",
            name: "Tobias Kolodziey (aka ToKoMotion)",
            intros: [
                "Reallusion Certified Content Developer for iClone/Character Creator/CrazyTalk",
                "Owner/Artist - Studio ToKoMotion",
                "Production of Animation - Visualization - Unity Game Dev / VR",
            ],
        }, {
            id: "Viktoriya Nesterenko",
            img: "Speaker_Viktoriya.jpg",
            name: "Viktoriya Nesterenko",
            intros: [
                "1st prize of Animation@Work 2018 contest: Business animation",
                "Reallusion Certified Director (3D animation) 2016",
                "Independent 3D and 2D artist",
                "Owner/Artist - Nestergal creative school-studio",
            ],
        }],
    },
    jp: {
        UPCOMING_TESTIMONIAL_DATA: [{
            content: "I've enjoyed the most the part where it was explained what PBR does best, what it doesn't do, and how to compensate for them with GI. I would recommend this webinar to anyone who has questions concerning the pros and cons of PBR, and how to get the best of it with iClone 7.",
            author: "Ken Kawashima"
        },
        {
            content: "hough the seminar addressed foundational methods to scene building, there is always something new to learn. I learned a few new tricks. Kai is extremely knowledgeable, entertaining and an excellent presenter. Sometimes though - as a suggestions from someone trying to learn the program - it would be nice to get a webinar that demonstrates the lesson step by step rather than jumping around.",
            author: "Joce Leger"
        },
        {
            content: "I like that it felt personal and that you couldn't see everyone elses questions while the webinar was happening, I like that unlike watching a video you feel part of a lecture or a private lesson, really enjoyed it, would def do another!",
            author: "Katrina Talbot"
        },
        {
            content: "Thanks to this webinar I gained increased knowledge about CT8 blending types as well as the use of image overlay utility for fine tuning in CT8. I also saw a effective workflow utilizing CT8,Character Creator, Sculptris and PhotoShop. I will have to watch the video a few more times so that I can take notes to feel more comfortable with the new knowledge and workflow. I watch as many webinars as I can and do recommend them.",
            author: "Vicki Wilson"
        },
        {
            content: "The specific part I enjoyed the most was the step by step live demo in realtime and seeing the immediate generated results and even witnessing the technical issues encountered along the way by the speaker. Yes, I would like to recommend this webinar because I have an opportunity to hear the questions of other participants and the responses they receive.",
            author: "Gee Lam"
        }],
        SPEAKER_INTRODUCTION_DATA: [{
            id: "Cameron_Hines", 
            img: "Speaker_Cameron.jpg",
            name: "Cameron Hines",
            intros: [
                "In pre-production in creating a Mobile Video Game Company",
                "Freelance Animator & 3D Artist at Creating Animated Media (CAM)",
                "Independent Game Maker 2 and Unity Game Designer",
                "Animator - Childish Gambino - \"Deep Web Tour Vlog\"",
            ],
        }, {
            id: "Cris_Moras", 
            img: "Speaker_Cris.jpg",
            name: "Cris Moras (aka Stuckon3D)",
            intros: [
                "3D generalist for more than 25 years",
                "Lighting and compositing specialist for 15 of those 25 years.",
                "Worked on TV shows (Star Trek: voyager, Deep Space mine), music videos, commercials, motion rides, and 13 animated feature films (at PDI/Dreamworks and Walt Disney Animation Studios), among those: Shrek 2 , Big Hero 6, Frozen, and Zootopia, all Oscar winning films.",
                "Director and art director for Westwood Studio Red Alert 2 Franchise and senior lead artist for Disney Interactive",
            ],
        }, {
            id: "Francesco_Tammaccaro",
            img: "Speaker_Francesco.png",
            name: "Francesco Tammaccaro (aka Frank’s Pencil)",
            intros: [
                "1st prize of Animation@Work 2018 contest: YouTuber animation",
                "Reallusion Certified Content Developer for CrazyTalk Animator",
                "Indipendent multimedia artist, over 10 years of experience",
                "Artist - Locogame.co.uk",
                "Trained in VR/AR applications development at EON Reality",
            ],
        }, {
            id: "Julian_Darley",
            img: "Speaker_Julian.jpg",
            name: "Julian Darley",
            intros: [
                "Writing and directing films since the early 1980s, including: music videos, documentaries, animated shorts, live action shorts.",
                "Now in pre-production for a feature film that uses mostly CGI backgrounds and will make heavy use of iClone for previz.",
            ],
        }, {
            id: "James_Martin",
            img: "Speaker_James.jpg",
            name: "James Martin",
            intros: [
                "Reallusion Certified Trainer - 10+ years training and production",
                "VFX Artist - REPLICAS (2017) - LOTUS Entertainment",
                "Character Animator - \"Survivor's Remorse\" - STARZ network",
                "Lead Animator - Corporate Executive Board (CEB)",
                "Lead Animator - \"Plato's Reality Machine\" (2012)",
                "Owner / Artist - MobaCap Motion capture On-Demand",
            ],
        }, {
            id: "Kai_DeNeve",
            img: "Speaker_Kai.jpg",
            name: "Kai DeNeve",
            intros: [
                "Developer Marketing Manager at Reallusion",
                "Reallusion Marketplace Manager",
                "Freelance Animator & 3D Artist at Neat Night Productions",
                "Independent Unreal Engine Game Designer",
                "Video Game Addict",
            ],
        }, {
            id: "Mark_Diaz",
            img: "Speaker_Mark.jpg",
            name: "Mark Diaz",
            intros: [
                "Short Film Director and Editor for Autumn Leave Films",
                "TEDx Speaker",
                "Teacher and CEO at 2DAnimation101",
                "Self-Taught Animator",
            ],
        }, {
            id: "Mike_Sherwood",
            img: "Speaker_mike.jpg",
            name: "Mike Sherwood (aka 3Dtest)",
            intros: [
                "Independent 3D artist and consultant, over 20 years CGI experience",
                "Specialist in real time character modelling and animation",
                "Worked as Creative Director at bioVirtual Ltd",
                "Worked with broadcast and games companies such as the BBC and EA",
                "Originally trained and worked as a theatre actor/ director",
            ],
        }, {
            id: "Tobias_Kolodziey",
            img: "Speaker_ToKo.jpg",
            name: "Tobias Kolodziey (aka ToKoMotion)",
            intros: [
                "Reallusion Certified Content Developer for iClone/Character Creator/CrazyTalk",
                "Owner/Artist - Studio ToKoMotion",
                "Production of Animation - Visualization - Unity Game Dev / VR",
            ],
        }, {
            id: "Viktoriya Nesterenko",
            img: "Speaker_Viktoriya.jpg",
            name: "Viktoriya Nesterenko",
            intros: [
                "1st prize of Animation@Work 2018 contest: Business animation",
                "Reallusion Certified Director (3D animation) 2016",
                "Independent 3D and 2D artist",
                "Owner/Artist - Nestergal creative school-studio",
            ],
        }],
    },
    tw: {
        UPCOMING_TESTIMONIAL_DATA: [{
            content: "I've enjoyed the most the part where it was explained what PBR does best, what it doesn't do, and how to compensate for them with GI. I would recommend this webinar to anyone who has questions concerning the pros and cons of PBR, and how to get the best of it with iClone 7.",
            author: "Ken Kawashima"
        },
        {
            content: "hough the seminar addressed foundational methods to scene building, there is always something new to learn. I learned a few new tricks. Kai is extremely knowledgeable, entertaining and an excellent presenter. Sometimes though - as a suggestions from someone trying to learn the program - it would be nice to get a webinar that demonstrates the lesson step by step rather than jumping around.",
            author: "Joce Leger"
        },
        {
            content: "I like that it felt personal and that you couldn't see everyone elses questions while the webinar was happening, I like that unlike watching a video you feel part of a lecture or a private lesson, really enjoyed it, would def do another!",
            author: "Katrina Talbot"
        },
        {
            content: "Thanks to this webinar I gained increased knowledge about CT8 blending types as well as the use of image overlay utility for fine tuning in CT8. I also saw a effective workflow utilizing CT8,Character Creator, Sculptris and PhotoShop. I will have to watch the video a few more times so that I can take notes to feel more comfortable with the new knowledge and workflow. I watch as many webinars as I can and do recommend them.",
            author: "Vicki Wilson"
        },
        {
            content: "The specific part I enjoyed the most was the step by step live demo in realtime and seeing the immediate generated results and even witnessing the technical issues encountered along the way by the speaker. Yes, I would like to recommend this webinar because I have an opportunity to hear the questions of other participants and the responses they receive.",
            author: "Gee Lam"
        }],
        SPEAKER_INTRODUCTION_DATA: [{
            id: "Cameron_Hines", 
            img: "Speaker_Cameron.jpg",
            name: "Cameron Hines",
            intros: [
                "In pre-production in creating a Mobile Video Game Company",
                "Freelance Animator & 3D Artist at Creating Animated Media (CAM)",
                "Independent Game Maker 2 and Unity Game Designer",
                "Animator - Childish Gambino - \"Deep Web Tour Vlog\"",
            ],
        }, {
            id: "Cris_Moras", 
            img: "Speaker_Cris.jpg",
            name: "Cris Moras (aka Stuckon3D)",
            intros: [
                "3D generalist for more than 25 years",
                "Lighting and compositing specialist for 15 of those 25 years.",
                "Worked on TV shows (Star Trek: voyager, Deep Space mine), music videos, commercials, motion rides, and 13 animated feature films (at PDI/Dreamworks and Walt Disney Animation Studios), among those: Shrek 2 , Big Hero 6, Frozen, and Zootopia, all Oscar winning films.",
                "Director and art director for Westwood Studio Red Alert 2 Franchise and senior lead artist for Disney Interactive",
            ],
        }, {
            id: "Francesco_Tammaccaro",
            img: "Speaker_Francesco.png",
            name: "Francesco Tammaccaro (aka Frank’s Pencil)",
            intros: [
                "1st prize of Animation@Work 2018 contest: YouTuber animation",
                "Reallusion Certified Content Developer for CrazyTalk Animator",
                "Indipendent multimedia artist, over 10 years of experience",
                "Artist - Locogame.co.uk",
                "Trained in VR/AR applications development at EON Reality",
            ],
        }, {
            id: "Julian_Darley",
            img: "Speaker_Julian.jpg",
            name: "Julian Darley",
            intros: [
                "Writing and directing films since the early 1980s, including: music videos, documentaries, animated shorts, live action shorts.",
                "Now in pre-production for a feature film that uses mostly CGI backgrounds and will make heavy use of iClone for previz.",
            ],
        }, {
            id: "James_Martin",
            img: "Speaker_James.jpg",
            name: "James Martin",
            intros: [
                "Reallusion Certified Trainer - 10+ years training and production",
                "VFX Artist - REPLICAS (2017) - LOTUS Entertainment",
                "Character Animator - \"Survivor's Remorse\" - STARZ network",
                "Lead Animator - Corporate Executive Board (CEB)",
                "Lead Animator - \"Plato's Reality Machine\" (2012)",
                "Owner / Artist - MobaCap Motion capture On-Demand",
            ],
        }, {
            id: "Kai_DeNeve",
            img: "Speaker_Kai.jpg",
            name: "Kai DeNeve",
            intros: [
                "Developer Marketing Manager at Reallusion",
                "Reallusion Marketplace Manager",
                "Freelance Animator & 3D Artist at Neat Night Productions",
                "Independent Unreal Engine Game Designer",
                "Video Game Addict",
            ],
        }, {
            id: "Mark_Diaz",
            img: "Speaker_Mark.jpg",
            name: "Mark Diaz",
            intros: [
                "Short Film Director and Editor for Autumn Leave Films",
                "TEDx Speaker",
                "Teacher and CEO at 2DAnimation101",
                "Self-Taught Animator",
            ],
        }, {
            id: "Mike_Sherwood",
            img: "Speaker_mike.jpg",
            name: "Mike Sherwood (aka 3Dtest)",
            intros: [
                "Independent 3D artist and consultant, over 20 years CGI experience",
                "Specialist in real time character modelling and animation",
                "Worked as Creative Director at bioVirtual Ltd",
                "Worked with broadcast and games companies such as the BBC and EA",
                "Originally trained and worked as a theatre actor/ director",
            ],
        }, {
            id: "Tobias_Kolodziey",
            img: "Speaker_ToKo.jpg",
            name: "Tobias Kolodziey (aka ToKoMotion)",
            intros: [
                "Reallusion Certified Content Developer for iClone/Character Creator/CrazyTalk",
                "Owner/Artist - Studio ToKoMotion",
                "Production of Animation - Visualization - Unity Game Dev / VR",
            ],
        }, {
            id: "Viktoriya Nesterenko",
            img: "Speaker_Viktoriya.jpg",
            name: "Viktoriya Nesterenko",
            intros: [
                "1st prize of Animation@Work 2018 contest: Business animation",
                "Reallusion Certified Director (3D animation) 2016",
                "Independent 3D and 2D artist",
                "Owner/Artist - Nestergal creative school-studio",
            ],
        }],
    },
    cn: {
        UPCOMING_TESTIMONIAL_DATA: [{
            content: "I've enjoyed the most the part where it was explained what PBR does best, what it doesn't do, and how to compensate for them with GI. I would recommend this webinar to anyone who has questions concerning the pros and cons of PBR, and how to get the best of it with iClone 7.",
            author: "Ken Kawashima"
        },
        {
            content: "hough the seminar addressed foundational methods to scene building, there is always something new to learn. I learned a few new tricks. Kai is extremely knowledgeable, entertaining and an excellent presenter. Sometimes though - as a suggestions from someone trying to learn the program - it would be nice to get a webinar that demonstrates the lesson step by step rather than jumping around.",
            author: "Joce Leger"
        },
        {
            content: "I like that it felt personal and that you couldn't see everyone elses questions while the webinar was happening, I like that unlike watching a video you feel part of a lecture or a private lesson, really enjoyed it, would def do another!",
            author: "Katrina Talbot"
        },
        {
            content: "Thanks to this webinar I gained increased knowledge about CT8 blending types as well as the use of image overlay utility for fine tuning in CT8. I also saw a effective workflow utilizing CT8,Character Creator, Sculptris and PhotoShop. I will have to watch the video a few more times so that I can take notes to feel more comfortable with the new knowledge and workflow. I watch as many webinars as I can and do recommend them.",
            author: "Vicki Wilson"
        },
        {
            content: "The specific part I enjoyed the most was the step by step live demo in realtime and seeing the immediate generated results and even witnessing the technical issues encountered along the way by the speaker. Yes, I would like to recommend this webinar because I have an opportunity to hear the questions of other participants and the responses they receive.",
            author: "Gee Lam"
        }],
        SPEAKER_INTRODUCTION_DATA: [{
            id: "Cameron_Hines", 
            img: "Speaker_Cameron.jpg",
            name: "Cameron Hines",
            intros: [
                "In pre-production in creating a Mobile Video Game Company",
                "Freelance Animator & 3D Artist at Creating Animated Media (CAM)",
                "Independent Game Maker 2 and Unity Game Designer",
                "Animator - Childish Gambino - \"Deep Web Tour Vlog\"",
            ],
        }, {
            id: "Cris_Moras", 
            img: "Speaker_Cris.jpg",
            name: "Cris Moras (aka Stuckon3D)",
            intros: [
                "3D generalist for more than 25 years",
                "Lighting and compositing specialist for 15 of those 25 years.",
                "Worked on TV shows (Star Trek: voyager, Deep Space mine), music videos, commercials, motion rides, and 13 animated feature films (at PDI/Dreamworks and Walt Disney Animation Studios), among those: Shrek 2 , Big Hero 6, Frozen, and Zootopia, all Oscar winning films.",
                "Director and art director for Westwood Studio Red Alert 2 Franchise and senior lead artist for Disney Interactive",
            ],
        }, {
            id: "Francesco_Tammaccaro",
            img: "Speaker_Francesco.png",
            name: "Francesco Tammaccaro (aka Frank’s Pencil)",
            intros: [
                "1st prize of Animation@Work 2018 contest: YouTuber animation",
                "Reallusion Certified Content Developer for CrazyTalk Animator",
                "Indipendent multimedia artist, over 10 years of experience",
                "Artist - Locogame.co.uk",
                "Trained in VR/AR applications development at EON Reality",
            ],
        }, {
            id: "Julian_Darley",
            img: "Speaker_Julian.jpg",
            name: "Julian Darley",
            intros: [
                "Writing and directing films since the early 1980s, including: music videos, documentaries, animated shorts, live action shorts.",
                "Now in pre-production for a feature film that uses mostly CGI backgrounds and will make heavy use of iClone for previz.",
            ],
        }, {
            id: "James_Martin",
            img: "Speaker_James.jpg",
            name: "James Martin",
            intros: [
                "Reallusion Certified Trainer - 10+ years training and production",
                "VFX Artist - REPLICAS (2017) - LOTUS Entertainment",
                "Character Animator - \"Survivor's Remorse\" - STARZ network",
                "Lead Animator - Corporate Executive Board (CEB)",
                "Lead Animator - \"Plato's Reality Machine\" (2012)",
                "Owner / Artist - MobaCap Motion capture On-Demand",
            ],
        }, {
            id: "Kai_DeNeve",
            img: "Speaker_Kai.jpg",
            name: "Kai DeNeve",
            intros: [
                "Developer Marketing Manager at Reallusion",
                "Reallusion Marketplace Manager",
                "Freelance Animator & 3D Artist at Neat Night Productions",
                "Independent Unreal Engine Game Designer",
                "Video Game Addict",
            ],
        }, {
            id: "Mark_Diaz",
            img: "Speaker_Mark.jpg",
            name: "Mark Diaz",
            intros: [
                "Short Film Director and Editor for Autumn Leave Films",
                "TEDx Speaker",
                "Teacher and CEO at 2DAnimation101",
                "Self-Taught Animator",
            ],
        }, {
            id: "Mike_Sherwood",
            img: "Speaker_mike.jpg",
            name: "Mike Sherwood (aka 3Dtest)",
            intros: [
                "Independent 3D artist and consultant, over 20 years CGI experience",
                "Specialist in real time character modelling and animation",
                "Worked as Creative Director at bioVirtual Ltd",
                "Worked with broadcast and games companies such as the BBC and EA",
                "Originally trained and worked as a theatre actor/ director",
            ],
        }, {
            id: "Tobias_Kolodziey",
            img: "Speaker_ToKo.jpg",
            name: "Tobias Kolodziey (aka ToKoMotion)",
            intros: [
                "Reallusion Certified Content Developer for iClone/Character Creator/CrazyTalk",
                "Owner/Artist - Studio ToKoMotion",
                "Production of Animation - Visualization - Unity Game Dev / VR",
            ],
        }, {
            id: "Viktoriya Nesterenko",
            img: "Speaker_Viktoriya.jpg",
            name: "Viktoriya Nesterenko",
            intros: [
                "1st prize of Animation@Work 2018 contest: Business animation",
                "Reallusion Certified Director (3D animation) 2016",
                "Independent 3D and 2D artist",
                "Owner/Artist - Nestergal creative school-studio",
            ],
        }],
    }
}